import { format } from 'date-fns';
import { FC, ReactNode } from 'react';

type PlanMetadataProps = {
  isBetaMode?: boolean;
  planId: string;
  generatedAt: string;
  content?: string | ReactNode;
};

const PlanMetadata: FC<PlanMetadataProps> = ({ isBetaMode, planId, generatedAt, content }) => {
  return (
    !!isBetaMode && (
      <div className="label my-6 inline-flex w-fit flex-col font-semibold text-gray-dark">
        {!!content && <span>{content}</span>}
        {!!planId && (
          <span>
            credit plan id:&nbsp;<i>{planId}</i>
          </span>
        )}
        {!!generatedAt && (
          <span>
            generated at:&nbsp;<i>{format(generatedAt, 'M/d/yyyy p')}</i>
          </span>
        )}
      </div>
    )
  );
};

export default PlanMetadata;
